import React from 'react';
import {ScrollView, View, StyleSheet} from 'react-native';
import Text from '../../../components/Text';
import {Card, Divider} from 'react-native-paper';
import {styles} from '../../../styles';
import Navbar from '../../../components/Navbar';
import {GateCard} from '../../../@types/GateCard';
import Container from '../../../components/Container';

const GateCardDetail = ({navigation, route}) => {
  const gateCard: GateCard = route.params?.gateCard;

  return (
    <Container>
      <Navbar navigation={navigation} title="Gatecard details" />
      <ScrollView
        style={localStyles.scrollView}
        showsVerticalScrollIndicator={false}>
        <Card style={localStyles.card}>
          <View style={localStyles.flexRow} />
          <View style={localStyles.row}>
            <Text style={styles.textLabel}>Card number</Text>
            <Text style={styles.detailsText}>{gateCard.cardNumber}</Text>
          </View>
          <Divider />
          <View style={localStyles.row}>
            <Text style={styles.textLabel}>Card holder name</Text>
            <Text style={styles.detailsText}>{gateCard.cardHolderName}</Text>
          </View>

          <Divider />
          <View style={localStyles.row}>
            <Text style={styles.textLabel}>Printed number</Text>
            <Text style={styles.detailsText}>{gateCard.printedNumber}</Text>
          </View>
          <Divider />
          <View style={localStyles.row}>
            <Text style={styles.textLabel}>User type</Text>
            <Text style={styles.detailsText}>{gateCard.userType}</Text>
          </View>
          <Divider />
          <View style={localStyles.row}>
            <Text style={styles.textLabel}>Type</Text>
            <Text style={styles.detailsText}>{gateCard.type}</Text>
          </View>
          <Divider />
          <View style={localStyles.row}>
            <Text style={styles.textLabel}>Disabled</Text>
            <Text style={styles.detailsText}>
              {gateCard.disabled ? 'True' : 'False'}
            </Text>
          </View>
          {gateCard.disabled === true && (
            <>
              <View style={localStyles.row}>
                <Text style={styles.textLabel}>Disabled message</Text>
                <Text style={styles.detailsText}>
                  {gateCard.diabledMessage}
                </Text>
              </View>
              <View style={localStyles.row}>
                <Text style={styles.textLabel}>Disabled date</Text>
                <Text style={styles.detailsText}>{gateCard.disabledDate}</Text>
              </View>
            </>
          )}
          <Divider />
          <View style={localStyles.row}>
            <Text style={styles.textLabel}>Always take picture</Text>
            <Text style={styles.detailsText}>
              {gateCard.alwaysTakePicture ? 'True' : 'False'}
            </Text>
          </View>
          <Divider />
          <View style={localStyles.row}>
            <Text style={styles.textLabel}>Issued Date</Text>
            <Text style={styles.detailsText}>
              {new Date(gateCard.issuedDate).toLocaleDateString()}
            </Text>
          </View>
          <Divider />
          <View style={localStyles.row}>
            <Text style={styles.textLabel}>Return date</Text>
            <Text style={styles.detailsText}>{gateCard.returnDate}</Text>
          </View>
          <Divider />
          <View style={localStyles.row}>
            <Text style={styles.textLabel}>Comments</Text>
            <Text style={styles.detailsText}>{gateCard.comments}</Text>
          </View>
        </Card>
      </ScrollView>
    </Container>
  );
};

const localStyles = StyleSheet.create({
  scrollView: {
    marginHorizontal: 8,
    paddingVertical: 16,
  },
  card: {
    padding: 8,
    marginBottom: 32,
  },
  flexRow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  row: {
    flexDirection: 'row',
    marginVertical: 12,
  },
});

export default GateCardDetail;
